import React, { useEffect } from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import { useAuth } from '../context/AuthContext';
import { X } from 'lucide-react';

interface AuthModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const AuthModal: React.FC<AuthModalProps> = ({ isOpen, onClose }) => {
    const { user, checkUser } = useAuth();

    useEffect(() => {
        if (user) {
            onClose();
        }
    }, [user, onClose]);

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content" style={{ maxWidth: '500px', padding: '0' }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '0.5rem' }}>
                    <button onClick={onClose} className="icon-button" aria-label="Close modal">
                        <X size={20} />
                    </button>
                </div>
                <div style={{ padding: '0 1rem 1rem 1rem' }}>
                    <Authenticator
                        loginMechanisms={['email']}
                        formFields={{
                            signUp: {
                                email: {
                                    order: 1
                                },
                                password: {
                                    order: 2
                                },
                                confirm_password: {
                                    order: 3
                                }
                            }
                        }}
                    >
                        {({ signOut, user }) => (
                            <div style={{ textAlign: 'center', padding: '2rem' }}>
                                <h3>Welcome, {user?.username}!</h3>
                                <p>You are successfully signed in.</p>
                                <button className="button primary" onClick={onClose}>Continue</button>
                            </div>
                        )}
                    </Authenticator>
                </div>
            </div>
        </div>
    );
};
